// "By context" bars on /voice-profile. Average overall score per call
// category. The tail copy comes from the highest + lowest categories.

import { dimFillVariant } from "../lib/scoring";

export type ContextRow = { name: string; score: number; readings: number };

export function ByContext({ rows, tail }: { rows: ContextRow[]; tail?: string }) {
  return (
    <section className="kpanel">
      <div className="kpanel-h">
        <h3>By context</h3>
        <span className="meta">avg score per type</span>
      </div>
      {rows.length === 0 ? (
        <p style={{ margin: "4px 0 8px", fontSize: 12, color: "rgb(var(--color-ink-muted))" }}>
          Need at least one reading per category to compare.
        </p>
      ) : (
        rows.map((r) => {
          const variant = dimFillVariant(r.score);
          const fillClass = variant ? `f ${variant}` : "f";
          return (
            <div key={r.name} className="ctx-row">
              <span className="name">{r.name}</span>
              <div className="bar">
                <div className={fillClass} style={{ ["--w" as string]: `${Math.round(r.score)}%` }} />
              </div>
              <span className="lab">{Math.round(r.score)}</span>
            </div>
          );
        })
      )}
      {tail && rows.length >= 2 ? (
        <p style={{ margin: "14px 0 0", fontSize: 11.5, color: "rgb(var(--color-ink-soft))", lineHeight: 1.5 }}>
          {tail}
        </p>
      ) : null}
    </section>
  );
}
